module.exports = __webpack_public_path__ + "img/257943-19-4.ab15e187.png";